import React from 'react';
import logo from "../arktemis media/dark-logo.jpg";
import { useNavigate, Link } from 'react-router-dom';

const Header = () => {
  const navigate = useNavigate();
  
  return (
    <div className="fixed top-0 left-0 w-full z-50 bg-black text-white flex flex-col md:flex-row items-center px-6 py-4 border-b border-gray-800">
      {/* Logo and Title */}
      <div className="flex items-center w-full md:w-auto">
        <img 
          src={logo} 
          alt="Arktemis Foundation Logo" 
          className="w-12 sm:w-14 md:w-16 lg:w-20 ml-4"
        />
        <div 
          className="cursor-pointer text-xl sm:text-2xl md:text-4xl lg:text-5xl font-extrabold ml-4 tracking-tight"
          onClick={() => navigate('/')}
          aria-label="Go to home page"
        >
          Arktemis Foundation
        </div>
      </div>

      {/* Navigation */}
      <div className="flex flex-wrap items-center gap-4 sm:gap-6 ml-auto mt-4 md:mt-0 text-base sm:text-lg md:text-xl mr-4">
        <Link to="/about" className="cursor-pointer hover:text-blue-400 transition-all duration-300 transform hover:scale-110" aria-label="About Us">
          About
        </Link>
        <Link to="/service" className="cursor-pointer hover:text-blue-400 transition-all duration-300 transform hover:scale-110" aria-label="Our Services">
          Services
        </Link>
        <Link to="/products" className="cursor-pointer hover:text-blue-400 transition-all duration-300 transform hover:scale-110" aria-label="Our Products">
          Products
        </Link>
        <div 
          className="cursor-pointer hover:text-blue-400 transition-all duration-300 transform hover:scale-110"
          onClick={() => navigate('/posts')}
          aria-label="Our Posts"
        >
          Posts
        </div>
        <a 
          href="https://biomassmatters.com"
          target="_blank"
          rel="noopener noreferrer"
          className="cursor-pointer text-green-500 hover:text-green-300 transition-all duration-300 transform hover:scale-110"
          aria-label="Visit our blog"
        >
          BiomassMatters
        </a>
        <div 
          className="relative inline-flex items-center justify-center p-0.5 overflow-hidden text-sm font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-green-400 to-blue-600 group-hover:from-green-400 group-hover:to-blue-600 hover:text-white dark:text-white focus:ring-4 focus:outline-none focus:ring-green-200 dark:focus:ring-green-800 cursor-pointer"
          onClick={() => navigate('/contact')}
          aria-label="Contact Us"
        >
          <span className="relative px-5 py-2.5 transition-all ease-in duration-75 bg-white dark:bg-gray-900 rounded-md group-hover:bg-opacity-0">
            Contact Us
          </span>
        </div>
      </div>
    </div>
  );
};

export default Header;